module.exports = __webpack_public_path__ + "img/klaus-a1-3.d82e34fe.jpg";